import { ErrorMessages } from '../types';

export const defaultErrorMessages: ErrorMessages = {
	default: 'Le champ est requis.'
};
